import React from "react";

const IconJCB = (props?: { iconFill?: string, className?: string, defs?: React.ReactNode }) => {
    return (
        <svg
            className={ props?.className }
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            clipRule="evenodd"
            viewBox="0 0 24 24"
        >
            { props?.defs ? props.defs : null }
            <path
                fillRule="nonzero"
                style={{fill: props?.iconFill}}
                d="M22 4H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2M9.45 15.315c0 .925-.751 1.667-1.667 1.667H5.338v-3.507s.751.211 1.712.211c1.584 0 2.051-.614 2.051-1.365v-1.932H7.673v1.941c0 .476-.311.824-.888.824-.485 0-.971-.146-1.438-.375V8.667C5.347 7.742 6.098 7 7.014 7H9.45zm4.615.018c0 .925-.751 1.667-1.667 1.667H9.953v-3.846c.421.357 1.154.586 2.335.531a7.2 7.2 0 0 0 1.31-.201v-.705c-.339.165-.742.33-1.264.366-.897.073-1.438-.366-1.438-1.145 0-.769.54-1.209 1.438-1.145.522.037.925.192 1.264.366v-.705s-.678-.174-1.31-.201c-1.181-.055-1.914.174-2.335.531v-2.18c0-.924.751-1.666 1.667-1.666h2.445zm4.597-.009c0 .925-.751 1.667-1.667 1.667H14.55v-3.388h2.582c.604 0 1.062-.33 1.062-.833 0-.467-.412-.769-.952-.806v-.018c.495-.064.76-.385.76-.76 0-.476-.394-.751-.925-.778l-.165-.009H14.56V8.667c0-.925.75-1.667 1.666-1.667h2.436zm-2.326-3.132.119.009a.445.445 0 0 1 .339.43.43.43 0 0 1-.339.43l-.119.009h-.961v-.879zm-.961-.494v-.806h.87l.092.009c.183.027.339.174.339.394s-.156.366-.339.394l-.092.009z">
            </path>
        </svg>
    )
};

export default IconJCB;
